var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ModalBase", { on: { "close-modal": _vm.closeModal } }, [
    _vm.account.stripeCustomerId
      ? _c("div", [
          _c("div", { staticClass: "popup__edit--title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("admins.limitMessage1", {
                    plan: _vm.plan.type,
                    maxCreators: _vm.plan.maxCreators
                  })
                ) +
                " "
            )
          ]),
          _c(
            "div",
            { staticClass: "popup__close", on: { click: _vm.closeModal } },
            [_c("span", { staticClass: "glicon-close-large" })]
          ),
          _c("div", { staticClass: "popup__text" }, [
            _vm._v(" " + _vm._s(_vm.$t("admins.limitMessage2")) + " ")
          ])
        ])
      : _c("div", [
          _c("div", { staticClass: "popup__edit--title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("admins.limitMessage1", {
                    plan: _vm.plan.type,
                    maxCreators: _vm.plan.maxCreators
                  })
                ) +
                " "
            )
          ]),
          _c(
            "div",
            { staticClass: "popup__close", on: { click: _vm.closeModal } },
            [_c("span", { staticClass: "glicon-close-large" })]
          ),
          _c("div", { staticClass: "popup__text" }, [
            _vm._v(" " + _vm._s(_vm.$t("admins.limitMessage3")) + " ")
          ]),
          _c(
            "div",
            { staticClass: "popup__buttons" },
            [
              _c("gl-button", {
                attrs: {
                  id: "admin.btn-contact",
                  "color-primary": "",
                  type: "button",
                  text: _vm.$t("subscriptions.planData.contact")
                },
                on: { onClick: _vm.contact }
              })
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }